import React from 'react'
import "../Style/Product.css"
import ConnetedNav from './Navbar'
import ConnetedFooter from './Footer'
import Navbar from '../nav/navbar'
import ConFooter from './conFooter'
import { FaRegCircleQuestion } from "react-icons/fa6";

const Product = () => {
    return (
        <div className='connetec__bankContainer'>
            <Navbar />
        <div className='2xl:container mx-auto pt-28'>
            <section className='py-20 px-5 xl:px-[100px]'>
                <div className='lg:flex px-5 justify-center gap-12 items-center'>
                    <div className='lg:w-2/3 lg:pb-0 pb-5 w-full space-y-8'>
                        <span className='produt_banner_heading block'>Simplify Business with Connected Banking.</span>
                        <span className='produt_banner_text block pr-14'>Stay on top of your cash flow, link bank accounts, pay vendors, receive payouts, and reconcile—everything managed seamlessly in one place.</span>
                        <div className='lg:block flex justify-center'>
                           <a href="https://merchant.haodapay.com/login" target='blank'><button className='py-4 w-1/2 lg:w-auto px-10'>Get Started Now</button> </a>
                        </div>
                    </div>
                    <div className='lg:w-1/3  w-full'>
                        <div className='flex justify-center items-center'>
                            <img src="/images/product_Frame.png" alt='banner image' className='banner_image' />
                        </div>
                    </div>
                </div>
            </section>

            <section className='py-20 bg-[#1B0849] px-[124px] 2xl:container mx-auto'>
                <div className='grid justify-center pb-16'>
                    <span className='connected_banking_heading'>End-to-End Solution</span>
                </div>

                <div className='grid justify-center pb-16'>
                    <span className='end_solution_text xl:w-[1030px]'>Business banking should be simple, secure, and built for growth. With Haoda Pay Connected Banking, you get all that and more. Backed by trusted partnerships with leading banks, our platform ensures seamless account integration, faster settlements, and smarter financial control — all in one place.</span>
                </div>

                <div className='lg:flex items-center justify-between pb-5  lg:pb-16 px-5 xl:px-32'>
                    <div className='lg:w-1/2 w-full lg:text-left  text-center grid gap-4 lg:gap-8 lg:pr-14'>
                        <div>
                            <span className='banking_list_heading block'>Seamless Account Linking</span>
                            <span className='banking_list_text block'>Connect your current account instantly via internet banking or at your bank branch.</span>
                        </div>

                        <div>
                            <span className='banking_list_heading block'>One Dashboard for Everything</span>
                            <span className='banking_list_text block'>Manage multiple accounts with complete visibility and real-time insights.</span>
                        </div>

                        <div>
                            <span className='banking_list_heading block'>Trusted & Secure</span>
                            <span className='banking_list_text block'>Built with advanced security standards and backed by reliable banking partners.</span>
                        </div>

                        <div>
                            <span className='banking_list_heading block'>Scalable for Growth</span>
                            <span className='banking_list_text block'>Whether you’re a startup, SME, or enterprise, our solutions adapt to your needs.</span>
                        </div>
                    </div>
                    <div className='lg:w-1/2 w-full'>
                        <div className='flex justify-center lg:justify-end'>
                            <img className='product_second_img' alt="image" src="/images/product_image_two.png" />
                        </div>
                    </div>
                </div>
                <span className='block end_solution_text'>Connect your Current Account today and move towards smarter banking.</span>
            </section>

            <section className='py-20 px-5 lg:px-[124px] xl:container mx-auto'>
                            <div className='flex justify-center pb-16'>
                                <span className='connected_banking_heading'>Key Benefits of Haoda Pay Connected Banking</span>
                            </div>
            
                            <div className='core_benefit_box_section flex-wrap'>
                                <div className='core_benefit_box'>
                                    <img src="/images/add-user.png" className='add-user' alt='add-user' />
                                    <span className='block core_benefit_box_heading'>End-to-End Security</span>
                                    <span className='block core_benefit_box_text'>Advanced encryption, 2FA, and fraud detection with full compliance.</span>
                                </div>
            
                                <div className='core_benefit_box'>
                                    <img src="/images/add-user.png" className='add-user' alt='add-user' />
                                    <span className='block core_benefit_box_heading'>Smarter Cash Flow</span>
                                    <span className='block core_benefit_box_text'>Centralized accounts, automated processes, and better financial control.</span>
                                </div>
            
                                <div className='core_benefit_box'>
                                    <img src="/images/add-user.png" className='add-user' alt='add-user' />
                                    <span className='block core_benefit_box_heading'>Scalable Solutions</span>
                                    <span className='block core_benefit_box_text'>Flexible for startups and enterprises, tailored to your growth.</span>
                                </div>
            
                                <div className='core_benefit_box'>
                                    <img src="/images/add-user.png" className='add-user' alt='add-user' />
                                    <span className='block core_benefit_box_heading'>24/7 Accessibility</span>
                                    <span className='block core_benefit_box_text'>Stay connected to your data anytime, anywhere.</span>
                                </div>
            
                                <div className='core_benefit_box'>
                                    <img src="/images/add-user.png" className='add-user' alt='add-user' />
                                    <span className='block core_benefit_box_heading'>Save Time & Costs</span>
                                    <span className='block core_benefit_box_text'>Automate reconciliation, tracking, and transfers for efficiency.</span>
                                </div>
                            </div>
                        </section>
        </div>
                   <ConFooter />

        </div>
    )
}

export default Product